import React from "react";

import CircularProgress from "veneer/CircularProgress";
import Stack from "veneer/Stack";
import Typography from "veneer/Typography";

import { useAppSelector } from "cortex/ui/src/hooks";
import {
  loaderStatusSelector,
  loaderTextSelector,
} from "cortex/ui/src/redux-store/loader/selectors";

export default function NavLoader() {
  const isLoading = useAppSelector(loaderStatusSelector);
  const text = useAppSelector(loaderTextSelector);

  if (!isLoading) return null;

  return (
    <Stack
      alignItems="center"
      data-testid="cortex-nav-loader"
      direction="row"
      spacing={1}
    >
      <CircularProgress size={15} />
      <Typography variant="h6">{text ? text : "Loading..."}</Typography>
    </Stack>
  );
}
